import { jsx as _jsx } from "react/jsx-runtime";
import { Textarea, formatCount } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
const SYMBOL_FORMS = ['символ', 'символа', 'символов'];
/**
 * Длина текста для счётчика. `codePoints` — символами (эмодзи и прочие
 * суррогатные пары считаются за один), как считают, например, заголовок
 * YouTube; `utf16` — как `string.length` и `z.string().max()`.
 */
export function textLength(text, countBy = 'utf16') {
    return countBy === 'codePoints' ? Array.from(text).length : text.length;
}
/**
 * Многострочный текст. `meta.showCount` + `meta.maxLength` — счётчик
 * «N символов из M» под полем (`meta.countBy` — чем считать). Ввод сверх
 * предела не обрезается: ошибку показывает схема при сохранении, а оператор
 * видит, на сколько превысил.
 */
export function TextareaWidget(props) {
    const { field, fieldState, meta, label, description, hint, readonly, disabled } = props;
    const value = field.value ?? '';
    const maxLength = typeof meta.maxLength === 'number' ? meta.maxLength : undefined;
    const countBy = meta.countBy === 'codePoints' ? 'codePoints' : 'utf16';
    const counter = meta.showCount === true && maxLength !== undefined
        ? `${formatCount(textLength(String(value), countBy), SYMBOL_FORMS)} из ${maxLength}`
        : null;
    const baseDescription = description ?? meta.description;
    const resolvedDescription = counter === null
        ? description
        : baseDescription
            ? `${String(baseDescription)} · ${counter}`
            : counter;
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: resolvedDescription, hint: hint, htmlFor: field.name, children: _jsx(Textarea, { ...field, id: field.name, value: value, placeholder: meta.placeholder, readOnly: readonly ?? meta.readonly, disabled: disabled }) }));
}
//# sourceMappingURL=textarea.js.map